/*******************************************************************************

// Project: JST
// Author: Prima-Line.de
// Date: 12.2017

********************************************************************************

  3. Off canvas menu
  4. Mobile Menu
  7. Dropdown Menu
  9. Responsive Videos
  12. Framework Scripts
  13. Gallery
  14. Equal Heights
  15. Related referenzen
  16. Referenzen Archive
  17. Full Slider
  18. Teasers
  19. List of shortcuts
  20. Header
  21. Feedbacks Slider
  22. Accordion
  23. Page Nav
  25. Text + Slider
  26. AGB
  27. Kontakt
  28. Hero
  29. Custom slider control
  30. Before After
  32. Scroll To
  33. Support Statistics
  34. Slider with title in orange box
  35. Animated Counter
  37. Page Academy showcase slider
  38. Smooth scroll
  39. Hash update on scroll
  40. Styled inputs
  41. Mini Slider
  42. Google Reviews
  43. Iframe Tab
  44. Conditional sections in the Contact Form 7
  45. Redirections for Contact Form 7

*******************************************************************************/

jQuery( document ).ready(function($) {

/* 3. Off canvas menu
------------------------------------------------------------------------------*/

  $('.toggle-nav').click(function() {
    // Calling a function in case you want to expand upon this.
    toggleNav();
  });

  function toggleNav() {
    if ($('#site-wrapper').hasClass('show-nav')) {
      // Do things on Nav Close
      $('#site-wrapper').removeClass('show-nav');
    } else {
      // Do things on Nav Open
      $('#site-wrapper').addClass('show-nav');
    }
  }

  // Fuction for hiding mobile navigation
  function hideNav() {
    if ($('#site-wrapper').hasClass('show-nav')) {
      $('#site-wrapper').removeClass('show-nav');
    }
  }

  // Hide navigation when user pressed Escape key on keyboard
  $(document).keyup(function(e) {
    if (e.keyCode === 27) {
      if ($('#site-wrapper').hasClass('show-nav')) {
        toggleNav();
      }
    }
  });

  // Define media query for large tablets
  const largeTablet = window.matchMedia("(min-width: 992px)");

  // Add a listener to handle changes in the media query status
  largeTablet.addEventListener('change', function(event) {
    if (event.matches) {
      // If the media query matches (screen width is at least 992px), hide the navigation
      hideNav();
    }
  });

  // Initial check to hide navigation if the media query already matches
  if (largeTablet.matches) {
    hideNav();
  }

/* 4. Mobile Menu
------------------------------------------------------------------------------*/

  $('ul.mob-menu li').has('ul').addClass('parentLi');
  $('ul.mob-menu li ul').addClass('sub-menu');

  $('ul.mob-menu .sub-menu').hide();

  $('ul.mob-menu .parentLi > a').on('click', function(event){
    event.preventDefault();
    $(this).toggleClass('expanded');
    $(this).parent().find('ul.sub-menu').slideToggle();
  });

/* 7. Dropdown Menu
------------------------------------------------------------------------------*/

  $('.site-header__top-menu .menu-item-has-children > a').on('click', function(e){
    e.preventDefault();
    $(this).closest('.site-header__top-menu').find('.opened').removeClass('opened');
    $(this).parent().toggleClass('opened');
  });

  // Hide dropdown after click outside the menu
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.site-header__top-menu .menu-item-has-children a').length) {
      $('.site-header__top-menu .menu-item-has-children').removeClass('opened');
    }
  });

  $('.menu-item-header').on('click', function(e) {
    e.preventDefault();
  });  
  
/* 9. Responsive Videos
/*******************************************************************************/

  const videoSources = ['iframe[src*="youtube"]', 'iframe[src*="vimeo"]'];

  document.querySelectorAll(videoSources.join(",")).forEach((video) => {
    video.style.maxWidth = "100%";
    video.style.height = "auto";
    video.style.aspectRatio = `${video.getAttribute("width")} / ${video.getAttribute("height")}`;
  });

/* 13. Gallery
/*******************************************************************************/

  // Initialize the gallery
  const galleries = document.querySelectorAll('.gal__theme-wrap');

  galleries.forEach(gallery => {
    const vertical = gallery.querySelector('.gal__vertical-in');
    const horizontal = gallery.querySelector('.gal__horizontal-in');
    const desc = gallery.querySelector('.gal__desc-in');
    const gotoLinks = gallery.querySelectorAll('.gal__goto');
    const altImgs = gallery.querySelectorAll('.gal__img-alt');
    const verticalContainer = gallery.querySelector('.gal__vertical');

    if (!vertical || !horizontal || !desc || !verticalContainer) return;

    $(vertical).slick({
      vertical: true,
      slidesToShow: 1,
      asNavFor: '.gal__horizontal-in, .gal__desc-in',
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 9,
            slidesToScroll: 9
          }
        }
      ]
    });

    $(horizontal)
      .on('init', function () {
        // Placeholder for optional callback
      })
      .slick({
        asNavFor: '.gal__vertical-in, .gal__desc-in',
        arrows: false,
        dots: true,
        mobileFirst: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: true,
              dots: false
            }
          }
        ]
      })
      .on('afterChange', function () {
        // Placeholder for optional callback
      });

    $(desc).slick({
      asNavFor: '.gal__vertical-in, .gal__horizontal-in',
      arrows: false
    });

    // Handle click events on .gal__goto links
    gotoLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const index = parseInt(link.dataset.goto, 10);
        $('.gal__horizontal-in').slick('slickGoTo', index);
      });
    });

    // Adjust the height of .gal__img-alt based on the height of .gal__vertical
    function updateAltImgHeight() {
      const height = verticalContainer.offsetHeight;
      altImgs.forEach(img => {
        img.style.height = `${height}px`;
      });
    }

    // Handle window resize using debounced helper
    if (window.Helpers && Helpers.onDebouncedResize) {
      Helpers.onDebouncedResize(updateAltImgHeight);
    }

    // Vanilla JavaScript alternative to imagesLoaded
    const images = verticalContainer.querySelectorAll('img');
    let loaded = 0;

    images.forEach(img => {
      if (img.complete) {
        loaded++;
      } else {
        img.addEventListener('load', () => {
          loaded++;
          if (loaded === images.length) updateAltImgHeight();
        });
      }
    });

    if (loaded === images.length) updateAltImgHeight();
  });

/* 14. Equal Heights
/*******************************************************************************/

  $.fn.matchHeight._maintainScroll = true;

  function updateGalleryHeights() {
    $('.gal__img-alt').height($('.gal__vertical').height());
  }

  $('.counter-item').matchHeight();
  $('.box__content--teaser').matchHeight();
  $('.post-teaser__title').matchHeight();
  $('.post-teaser__in').matchHeight();
  $('.related-items__content-in').matchHeight();
  $('.related-items__link').matchHeight();
  $('.lg-img-teasers__teasers .box__content-in').matchHeight();
  $('.lg-img-teasers__teasers .box__link').matchHeight();
  $('.teaser-sm__wrp .teaser-sm').matchHeight();
  $('.mod__quote-content').matchHeight();
  $('.mod').matchHeight();
  $('.half-img-txt__txt, .half-img-txt__img-wrap').matchHeight();
  $('.step__title').matchHeight();
  $('.quote__txt').matchHeight();
  $('.quote').matchHeight();
  $('.hero-alt__desc').matchHeight();
  $('.three-cols-content__col-txt, .three-cols-content__col-quote, .three-cols-content__col-img-wrap').matchHeight();
  $('.box__col-img-wrap, .box__col-txt').matchHeight();
  $('.cform__topic-item').matchHeight({byRow: false});
  $('.post-type-archive-aktuelles .box__content-in').matchHeight();
  $('.modul-b__list-select, .modul-b__list-text').matchHeight();
  $('.box--presse-horizontal-col-2').matchHeight();
  $('.box--presse .box__title').matchHeight();
  $('.box--presse .box__meta').matchHeight();
  $('.module__img-wrap').matchHeight();
  $('.orange-block-with-icons__content').matchHeight();
  $('.l-two-cols__wrap--projektberichte .l-two-cols__main, .l-two-cols__wrap--projektberichte .l-two-cols__side').matchHeight();
  $('.academy-showcase__box-content').matchHeight();
  $('.package__header').matchHeight();
  $('.box-emoticon__img').matchHeight();
  $('.b-teasers-alt__teaser').matchHeight();
  
  //$('.b-text-slider-with-tabs__left, .b-text-slider-with-tabs__right').matchHeight();

  $('body').imagesLoaded(function(){
    $.fn.matchHeight._update();
  });

  $( window ).load(function() {
    $.fn.matchHeight._update();
    setTimeout(updateGalleryHeights, 1000);
  });

/* 15. Related referenzen
/*******************************************************************************/

  $('.related-items__slider').slick({
    slidesToShow: 1,
    arrows: false,
    dots: true,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  

/* 17. List of logo
/*******************************************************************************/


 $('.logo-list__slider').slick({
    accessibility: false,
    mobileFirst: true,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6
      }
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 8,
        slidesToScroll: 1
      }
    }
  ]
});

  $('.logo-list__slider').on('afterChange', function() {
    $(window).trigger('scroll');
  });


/* 17. Full Slider
/*******************************************************************************/

  $('.full-sider__wrap').slick({
    fade: true,
    arrows: false,
    dots: true
  });

  $('.full-slider__slide').matchHeight();

/* 18. Teasers
/*******************************************************************************/

  $('.teaser__slider-wrap').slick({
    arrows: false,
    adaptiveHeight: true
  });

  $('.teaser__cnt').matchHeight();
  $('.teaser').matchHeight();
  //$('.teaser--list, .teaser--slider').matchHeight();

/* 19. List of shortcuts
/*******************************************************************************/

  $('.js-redirect-to-page').on('click', function(e){
    e.preventDefault();
    var url = $(this).closest('.shortcuts__wrap').find('select').val();
    window.location.replace(url);
  });

/* 20. Header
/*******************************************************************************/


  // function setup_top_spacing() {
  //   $('.site-content').css('padding-top', $('.site-header').outerHeight() + 'px');
  //
  //   if($('#wpadminbar').length > 0) {
  //     $('.site-header').css('top', $('#wpadminbar').outerHeight() + 'px');
  //   }
  // }
  //
  // setup_top_spacing();
  // $(window).on("debouncedresize", function( event ) {
  //   setup_top_spacing();
  // });

  function resizeHeaderOnScroll() {
    var distanceY = window.pageYOffset || document.documentElement.scrollTop,
    shrinkOn = $('.site-header').outerHeight() + 10,
    headerEl = $('.site-header');

    if (distanceY > shrinkOn) {
      headerEl.addClass('site-header--small');
    } else {
      headerEl.removeClass('site-header--small');
    }
  }

window.addEventListener('scroll', resizeHeaderOnScroll);

/* 21. Feedbacks Slider
/*******************************************************************************/

  $('.feedbacks-slider').slick({
    slidesToShow: 1,
    arrows: false,
    dots: false,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.feedbacks-slider-col-2').slick({
    slidesToShow: 1,
    arrows: false,
    dots: false,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

/* 22. Accordion
/*******************************************************************************/

  // Hide all accordions
  var allPanels = $('.accordion dd').hide();
  var allTitles = $('.accordion dt');

  $('.accordion dt > a').click(function(e) {
    e.preventDefault();
    $this = $(this);
    $title = $this.parent();
    $target =  $this.parent().next();

    if(!$target.hasClass('accordion__text--active')){
      allPanels.removeClass('accordion__text--active').slideUp();
      allTitles.removeClass('accordion__subtitle--active');
      $target.addClass('accordion__text--active').slideDown();
      $title.addClass('accordion__subtitle--active');
    }
    else {
      allPanels.removeClass('accordion__text--active').slideUp();
      allTitles.removeClass('accordion__subtitle--active');
    }
    return false;
  });

/* 23. Page Nav
/*******************************************************************************/

  $('.page-nav li.scroll a').on('click', function(e){
    e.preventDefault();
    // $(this).closest('.page-nav').find('a').removeClass('page-nav__item--active');
    // $(this).addClass('page-nav__item--active');
    var header_height = $('.site-header').outerHeight();
    var target_el = $(this).attr('href');
    target_el = target_el.replace('#', '');
    target_el = $('#' + target_el);
    var scroll_target = target_el.offset().top - header_height;
    scroll_target = scroll_target + 'px';
    $.scrollTo(scroll_target, {
      duration: 1000,
    });
  });

/* 25. Text + Slider
/*******************************************************************************/

  $('.txt-slider__txt-in, .txt-slider__slide-in').matchHeight();

  $('.txt-slider__slider').slick({
    fade: true
  });


/* 26. AGB
/*******************************************************************************/

  $('.c-box__more-link').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('c-box__more-link--active');
    $(this).closest('.c-box').find('.c-box__content-invisible').slideToggle();
  });

/* 27. Kontakt
/*******************************************************************************/

  // Topic
  $('#topic-fake-fields .cform__topic-item').on('click', function(){
    var that = $(this);
    var checkboxID = that.data('checkbox');
    var connectedCheckbox = $('#topic-real-fields input[value="' + checkboxID + '"]');
    var connectedSelect = $('#topic-real-field');
    var chosenOptions = [];
    if(connectedSelect.val()) {
      chosenOptions = connectedSelect.val();
    }

    if(that.hasClass('cform__topic-item--active')) {
      that.removeClass('cform__topic-item--active');
      for(var i = chosenOptions.length - 1; i >= 0; i--) {
        if(chosenOptions[i] === checkboxID) {
          chosenOptions.splice(i, 1);
        }
      }
      connectedSelect.val(chosenOptions);
    }
    else {
      that.addClass('cform__topic-item--active');
      chosenOptions.push(checkboxID);
      connectedSelect.val(chosenOptions);
    }
  });

  // Acceptance
  $('#acceptance-fake-fields .cform__topic-item--radio').on('click', function(){
    var that = $(this);
    var fieldID = that.data('checkbox');
    if(that.hasClass('cform__topic-item--active')) {
      that.removeClass('cform__topic-item--active');
      $('input[name="' + fieldID + '"][value="false"]').prop("checked",true);
    }
    else {
      that.addClass('cform__topic-item--active');
      $('input[name="' + fieldID + '"][value="true"]').prop("checked",true);
    }
  });

  $('.set-idACECHFFFEB input').on('change' ,function(){
    if($(this).is(':checked')) {
      $('input[name="idACECHFFFEB"][value="true"]').prop("checked",true);
    }
    else {
      $('input[name="idACECHFFFEB"][value="false"]').prop("checked",true);
    }
  });

  $('#acceptance-fake-fields .cform__topic-item--checkbox').on('click', function(){
    var that = $(this);
    var fieldID = that.data('checkbox');
    if(that.hasClass('cform__topic-item--active')) {
      that.removeClass('cform__topic-item--active');
      $('#' + fieldID + ' input').prop("checked",false);
    }
    else {
      that.addClass('cform__topic-item--active');
      // console.log($('#acceptance-real-fields input[name="' + fieldID + '"][value="true"]'));
      $('#' + fieldID + ' input').prop("checked",true);
    }
  });

  // Yes/No
  $('.yes-no > div').on('click', function(){
      var that = $(this);
      var parent = that.parent();
      var fieldName = parent.data('field');
      if(parent.hasClass('yes-no--active')) {
        parent.removeClass('yes-no--active');
        $('input[name="' + fieldName + '"][value="false"]').prop("checked",true);
      }
      else {
        parent.addClass('yes-no--active');
        $('input[name="' + fieldName + '"][value="true"]').prop("checked",true);
      }
  });

/* 28. Hero
/*******************************************************************************/

  if($('.hero__content-img').length > 0) {
    var list = $('.hero__content-img').closest('.hero__left').find('ul');
    $('.hero__content-img').insertBefore(list);
  }

/* 29. Custom slider control
/*******************************************************************************/

  $('.teaser__slider-nav-prev').on('click', function(){
    $(this).parent().next().slick("slickPrev");
  });

  $('.teaser__slider-nav-next').on('click', function(){
    $(this).parent().next().slick("slickNext");
  });

/* 30. Before After
/*******************************************************************************/

  $('.block-top__ba-wrap').imagesLoaded( function() {
    $(window).trigger('slidein', {right: 50, left: 5, end: 50}); // Ustawia animację na bardziej symetryczną i rozpoczynającą od środka
  });

/* 32. Scroll To
/*******************************************************************************/

  $('a[href*="#"].js-scroll')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // console.log($(this).attr('href'));
    var current_hash = $(this).attr('href');
    //var current_hash = '#dupa';
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        var header_height = $('.site-header').outerHeight();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          window.location.hash = current_hash;
        });
      }
    }
  });

/* 33. Support Statistics
------------------------------------------------------------------------------*/

  $('.b-sup-stat__slider-header-g').matchHeight();
  $('.b-sup-stat__slider-desc').matchHeight();

  $('.b-sup-stat__slider-wrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    mobileFirst: true,
    adaptiveHeight: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      }
    ]
  })
  .on('beforeChange', function(){
    $.fn.matchHeight._update();
  })
  .on('afterChange', function(){
    $.fn.matchHeight._update();
  });

/* 34. Slider with title in orange bix
------------------------------------------------------------------------------*/

  $('.slider_with_orange_box__slider').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true

    });

/* 35. Animated Counter
------------------------------------------------------------------------------*/

  $(".counter").countimator();
  
/* 37. Page academy showcase slider
------------------------------------------------------------------------------*/

  $('.academy-showcase__col-right__slider').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    adaptiveHeight: true
  });

  $( ".academy-paket__detailed-description" ).hide();

  $( ".academy__accordion" ).on( "click", function(e) {
    e.preventDefault();
    $(this).toggleClass('box-time__plus-icon-link--active');
    $(this).closest('.academy-paket').next().slideToggle();
  });

  $('.box-time__head').on('click', function(e){
    e.preventDefault();
    $(this).parent().next().toggleClass('box-time__plus-icon-link--active');
    $( ".academy-paket__detailed-description" ).slideToggle();
  });

/* 38. Smooth scroll
------------------------------------------------------------------------------*/

  // Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var originalHash = $(this).attr('href');
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function(){
          window.location.hash = originalHash;
        });
      }
    }
  });

/* 39. Hash update on scroll
------------------------------------------------------------------------------*/

  function isElementInViewport (el) {
    // special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    var rect = el.getBoundingClientRect();
    //console.log('top: ' + rect.top + ' left: ' + rect.left + ' bottom: ' + rect.bottom + ' height: ' + $(window).height());
    // console.log(rect.top);
    return (
      rect.top >= 0 && rect.top < 300
    );
  }

  // listen for the scroll event
  if($('.academy-paket').length > 0 || $('.cardboard-form').length > 0) {
    $(document).on("scroll", function() {
      // check if the anchor elements are visible
      $(".academy-paket, .cardboard-form").each(function (idx, el) {
        if ( isElementInViewport(el) ) {
          // update the URL hash
          if (window.history.pushState) {
            var urlHash = "#" + $(el).attr("id");
            window.history.pushState(null, null, urlHash);
          }
        }
      });
    });
  }

  /* 34. Slider with tabs
  ------------------------------------------------------------------------------*/

    $('.slider__tab-wrap').slick({
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true

      });

/* 40. Styled inputs
------------------------------------------------------------------------------*/

  function setStyledStatus($wrap) {
    var styledInput = $wrap.find('input');
    if(styledInput.is(':checked')) {
      $wrap.addClass('is-checked');
    }
    else {
      $wrap.removeClass('is-checked');
    }
  }

  $('.c-styled-checkbox').each(function(){
    setStyledStatus($(this));
  });

  $('.c-styled-checkbox').on('change', function(){
    setStyledStatus($(this).closest('.c-styled-checkbox'));
  });

/* 41. Mini Slider
------------------------------------------------------------------------------*/

  $('.c-mini-slider__in').slick({
    arrows: false,
    dots: true
  });

/* 42. Google Reviews
------------------------------------------------------------------------------*/
 
  $('.js-open-comments').on('click', function(e){
    e.preventDefault();
    $('.rplg-form.rplg-form-left').toggle();
  });
  
/* 44. Content + Image (dark bacground slider)
/*******************************************************************************/

$('.cnt-img-dark__image-slider').slick({
  fade: true,
  arrows: false,
  autoplay: true,
  speed: 300,
});


/* 43. Iframe Tab
/*******************************************************************************/


$('.iframe-tab__button--first').on('click', function() {
  $(this).addClass('active');
  $('.iframe-tab__first').addClass('active');
  $('.iframe-tab__button--second').removeClass('active');
  $('.iframe-tab__second').removeClass('active');
});
$('.iframe-tab__button--second').on('click', function() {
  $(this).addClass('active');
  $('.iframe-tab__second').addClass('active');
  $('.iframe-tab__button--first').removeClass('active');
  $('.iframe-tab__first').removeClass('active');
});

  var vidElem = $('.b-text-slider-with-tabs__video')[0];
  // console.log(vidElem);
  $(vidElem).on("ended", function () {
    vidElem.currentTime = 10;
    vidElem.play();
  });

/* 44. Conditional sections in the Contact Form 7
/*******************************************************************************/ 

  var forms = document.querySelectorAll('.wpcf7-form');

  forms.forEach(function(form) {
    form.addEventListener('input', function(event) {
      var conditionalBlocks = form.querySelectorAll('.conditional-block');
      
      conditionalBlocks.forEach(function(block) {
        var fieldName = block.getAttribute('data-if-field');
        var notFieldName = block.getAttribute('data-ifnot-field');
        var targetField = form.querySelector('[name="' + (fieldName || notFieldName) + '"]');

        if (targetField) {
          if (fieldName && targetField.value) {
            block.style.display = 'block';
          } else if (notFieldName && !targetField.value) {
            block.style.display = 'block';
          } else {
            block.style.display = 'none';
          }
        }
      });
    });
  });

/* 45. Redirections for Contact Form 7
/*******************************************************************************/ 

  document.addEventListener('wpcf7mailsent', function(event) {
    if (theme_settings.redirectsMap[event.detail.contactFormId]) {
        location = theme_settings.redirectsMap[event.detail.contactFormId];
    }
  }, false);

  $('.tab-button-active').addClass('active');
  $('.tab-content-active').addClass('active');

  $('.tab-button-active').on('click', function() {
    $(this).addClass('active');
    $('.tab-content-active').addClass('active');

    $('.tab-button-archived').removeClass('active');
    $('.tab-content-archived').removeClass('active');
  });

  $('.tab-button-archived').on('click', function() {
    $(this).addClass('active');
    $('.tab-content-archived').addClass('active');

    $('.tab-button-active').removeClass('active');
    $('.tab-content-active').removeClass('active');
  });

// Obsługa kliknięcia na linki kotwicowe
jQuery('a[href*="#"]:not([href="#"])').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = jQuery(this.hash);
    target = target.length ? target : jQuery('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offset = 150; // Stały offset (150px)
      var targetOffset = target.offset().top - offset; // Obliczamy docelową pozycję z uwzględnieniem offsetu
      jQuery('html, body').animate({
        scrollTop: targetOffset // Przewijamy do docelowej pozycji z uwzględnieniem offsetu
      }, 1000);
      return false;
    }
  }
});
  
}); // End jQuery code


